import React, {useState} from 'react';

import AnalysisViewSelector from 'analysis-tool/ui/components/AnalysisViewSelector';
import {PipelineGraphQL, PipelineViewGraphQL} from 'pipelines/PipelineTypes';
import Modal from 'ui-library/modals/Modal';

interface LayoutViewPickerProps {
  analysis: PipelineGraphQL;
  onRequestClose: () => void;
  onRequestSubmit: (view: PipelineViewGraphQL) => void;
}

export default function LayoutViewPicker({
  analysis,
  onRequestClose,
  onRequestSubmit,
}: LayoutViewPickerProps): JSX.Element {
  const [selectedView, setSelectedView] = useState<PipelineViewGraphQL | null>(null);

  return (
    <Modal
      title="Select View"
      onRequestClose={onRequestClose}
      onRequestSubmit={() => {
        if (selectedView != null) {
          onRequestSubmit(selectedView);
        }
      }}
      buttons={[
        {text: 'Cancel', cancel: true},
        {text: 'Add', submit: true, style: 'primary', disabled: selectedView == null},
      ]}
      closeable={true}
    >
      <AnalysisViewSelector
        analysis={analysis}
        topLevelOnly={false}
        selectedView={selectedView}
        onSelect={setSelectedView}
      />
    </Modal>
  );
}
